<template>
  <div :class="['message-text-container', { expanded: isExpanded }]">
    <!-- 顶部操作栏 -->
    <div class="content-header">
      <div class="header-left">
        <img
          v-if="isExpanded"
          class="action-btn collapse-btn"
          @click="showHistoryList"
          :src="cdnUrl + 'ai-collaspe.svg'"
          alt=""
        />
        <button class="back-btn" @click="handleBack">
          <img :src="cdnUrl + 'ai-left-icon.svg'" alt="返回" />
        </button>
        <span class="content-title">短信文案生成</span>
      </div>
      <div class="content-actions">
        <template v-if="!isExpanded">
          <el-tooltip content="新建对话" placement="top">
            <img
              class="action-btn"
              @click="handleEdit"
              :src="cdnUrl + 'ai-add.svg'"
              alt=""
            />
          </el-tooltip>
          <el-tooltip content="历史对话" placement="top">
            <img
              class="action-btn"
              @click="handleRecord"
              :src="cdnUrl + 'ai-record.svg'"
              alt=""
            />
          </el-tooltip>
        </template>
        <el-tooltip v-if="isExpanded" content="收起" placement="top">
          <img
            class="action-btn"
            @click="toggleExpand"
            :src="cdnUrl + 'ai-sx.svg'"
            alt=""
          />
        </el-tooltip>
        <el-tooltip v-else content="展开" placement="top">
          <img
            class="action-btn"
            @click="toggleExpand"
            :src="cdnUrl + 'ai-full.svg'"
            alt=""
          />
        </el-tooltip>
        <img
          class="action-btn"
          @click="handleClose"
          :src="cdnUrl + 'ai-closed.svg'"
          alt=""
        />
      </div>
    </div>

    <!-- 表单区域 -->
    <div class="form-section">
      <el-form :model="form" class="ai-form" label-width="auto">
        <el-form-item label="活动主题:" required>
          <el-input
            v-model="form.activityName"
            placeholder="请输入营销活动主题，例如618大促、双十一名称"
            maxlength="32"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="利益点:">
          <el-input
            class="point-input"
            type="textarea"
            v-model="form.point"
            placeholder="请输入活动利益点或优惠等，多个内容用英文逗号隔开"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="150"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="字数限制:" required>
          <el-input
            v-model="form.wordLimit"
            placeholder="请输入字数限制"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动链接:">
          <div class="flex-row">
            <el-radio-group v-model="form.containLink">
              <el-radio :label="1">包含链接</el-radio>
              <el-radio :label="0">不包含链接</el-radio>
            </el-radio-group>
            <el-tooltip
              content="为防止超过字数上限，选择包含短链接时，短链接以15个字数计算"
              placement="bottom"
            >
              <img
                class="tips-icon"
                :src="cdnUrl + 'ai-question-icon.svg'"
                alt=""
              />
            </el-tooltip>
          </div>
        </el-form-item>
        <el-form-item label="" class="button-item">
          <div class="button-item__wrap">
            <div class="generate-btn" @click="createAI(0)">立即生成</div>
            <div class="tips">
              每天限使用<span class="num">20</span>次，今日还剩余<span
                class="num"
                >{{ AITimes }}</span
              >次(重新生成也消耗次数)
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 生成结果区域 -->
    <div class="result-section">
      <div class="result-section__wrap">
        <div class="chat_window" id="chat_window" v-if="chatList.length">
          <div
            class="item"
            :class="item.type == 2 ? 'left' : 'right'"
            v-for="(item, index) in chatList"
            :key="index"
          >
            <div class="message" :class="item.type == 2 ? 'AI' : 'monkey'">
              <loading v-if="item.isLoading" />
              <template v-else>
                <span>{{ item.showText }}</span>
                <handle
                  v-if="item.type == 2"
                  :item="item"
                  :copyText="item.showText"
                  :type="type"
                  :isCreating="isCreating"
                  :showLikeAndUnlike="false"
                  :showRegenerate="index + 1 == chatList.length && isNeedAgain"
                  @regenerate="createAI(1, item.id)"
                  @add="addFn"
                />
              </template>
            </div>
          </div>
        </div>
        <template v-else>
          <div class="result-placeholder">
            <img :src="cdnUrl + 'ai-wa.svg'" alt="" class="result-icon" />
            <p class="result-desc">输入你的文案诉求，即刻生成短信文案</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AIList, monkey, AI, AIAgain } from "@/api/ai/newAi.js";
import handle from "@/components/ai/components/handle.vue";
import loading from "@/components/ai/components/loading.vue";

export default {
  name: "MessageText",
  props: {
    isExpanded: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number, // 0: 顶部 1: 短信操作
      default: 0,
    },
  },
  components: {
    handle,
    loading,
  },
  computed: {
    ...mapGetters(["sellerId"]),
  },
  data() {
    return {
      cdnUrl: "https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/",
      form: {
        activityName: "",
        point: "",
        wordLimit: "",
        containLink: 1,
        buildType: 1,
      },
      isCreating: false, // 是否创建中，防止重复点击
      chatList: [], // 对话内容
      isNeedAgain: false, // 是否需要重新生成按钮
      timer: null,
      timerNum: 0, // 用于计算10秒内AI应答是否成功
      AITimes: 20, // 剩余次数
    };
  },
  mounted() {
    this.AIListFn();
  },
  methods: {
    handleBack() {
      this.$emit("back");
    },
    handleEdit() {
      this.$emit("edit");
    },
    handleRecord() {
      this.$emit("record");
    },
    toggleExpand() {
      this.$emit("toggleExpand");
    },
    handleClose() {
      this.$emit("close");
    },
    showHistoryList() {
      this.$emit("showHistoryList");
    },
    AIListFn() {
      const query = {
        platfromCode: "TB",
        sellerId: this.sellerId || "",
      };
      AIList(query).then((res) => {
        this.AITimes = 20 - Number(res.data.cnt || 0);
        this.chatList = res.data.record || [];
        this.scrollWindow();
      });
    },
    // 生成AI内容
    createAI(type, id) {
      // 0: 生成新内容，1：重新生成内容
      // 检验必填项
      // 条件生成
      if (!this.AITimes) {
        return this.$message.warning("今日次数已用完！");
      }
      if (!this.form.activityName) {
        return this.$message.error("活动名称不能为空！");
      }
      if (!this.form.wordLimit) {
        return this.$message.error("字数限制不能为空！");
      }

      // 节流
      if (this.isCreating) {
        return;
      }

      if (!type) {
        // 创建新的AI内容，右侧monkey需要增加一条消息记录
        this.isCreating = true;
        monkey({
          ...this.form,
          sellerId: this.sellerId || "",
        })
          .then((res) => {
            // 先生成一条monkey记录，再根据monkey的id请求生成AI应答记录
            if (res.code == 200) {
              this.chatList.push(res.data);
              this.chatList.push({
                isLoading: true,
                showText: "正在思考...",
                type: 2,
              }); // 如果是创建新的AI内容，需要存入一条新的AI内容 stringA，后续做逐字打印效果
              this.scrollWindow();
              this.AIFn(res.data.id);
              this.timer = setInterval(() => {
                this.timerNum++;
              }, 1000);
            } else {
              this.isCreating = false;
              this.$message.error(res.message);
            }
          })
          .catch(() => {
            this.isCreating = false;
          });
      } else {
        // 重新生成AI内容
        if (!id) {
          // 超时未应答，最后一项非聊天列表内容，手动生成新的AI应答
          this.createAI(0);
          return;
        }
        this.isCreating = true;
        AIAgain(id)
          .then((res) => {
            // 重新生成一条monkey记录，再根据monkey的id请求生成AI应答记录
            if (res.code == 200) {
              this.chatList.push(res.data);
              this.chatList.push({
                isLoading: true,
                showText: "正在思考...",
                type: 2,
              }); // 如果是创建新的AI内容，需要存入一条新的AI内容 stringA，后续做逐字打印效果
              this.scrollWindow();
              this.AIFn(res.data.id);
              this.timer = setInterval(() => {
                this.timerNum++;
              }, 1000);
            } else {
              this.isCreating = false;
              this.$message.error(res.message);
            }
          })
          .catch(() => {
            this.isCreating = false;
          });
      }
    },
    AIFn(id) {
      // 10秒内无应答不再循环
      if (this.timerNum == 10) {
        clearInterval(this.timer);
        this.timerNum = 0;
        this.isCreating = false;
        this.isRefresh = false;
        this.chatList[this.chatList.length - 1] = {
          showText: "这个接口暂时有点忙，请稍后再试哦~",
          type: 2,
        };
        return;
      }

      // stringA stringB用于做逐字打印效果
      let stringA = { showText: "", type: 2 }; // 逐字存入聊天窗口的内容
      let stringB = { showText: "", type: 2 }; // 完整AI消息内容
      AI(id).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            clearInterval(this.timer);
            this.timerNum = 0; // 成功应答后，10秒计时重置
            this.isNeedAgain = true;
            this.AITimes--; // AI应答成功后手动将次数减一
            stringB = res.data;
            stringA.id = res.data.id;
            AIPrintFn();
            // 逐字打印完之后在放开按钮操作
            setTimeout(() => {
              this.isCreating = false;
            }, stringB.showText.length * 30);
          } else {
            this.AIFn(id);
          }
        } else {
          this.isCreating = false;
          this.$message.error(res.message);
        }
      });

      // 逐字打印效果
      const AIPrintFn = () => {
        this.chatList[this.chatList.length - 1] = stringA;
        this.$forceUpdate();
        this.scrollWindow();
        if (stringA.showText.length >= stringB.showText.length) {
          // 退出递归
          return;
        } else {
          // stringA仍然比stringB短，进入下一次等待和递归
          setTimeout(() => {
            stringA.showText += stringB.showText.charAt(
              stringA.showText.length
            );
            this.scrollWindow();
            AIPrintFn(stringA, stringB);
          }, 30);
        }
      };
    },
    // 滚动AI聊天窗口
    scrollWindow() {
      this.$nextTick(() => {
        const objDiv = document.getElementById("chat_window");
        setTimeout(() => {
          objDiv.scrollTop = objDiv.scrollHeight;
        }, 10);
      });
    },
    // 添加到短信输入框
    addFn(item) {
      if (item.showText.indexOf("#自定义短链接#") != -1) {
        this.$message.error(
          "短信文案中包含#自定义短链接#，请使用辅助工具插入短网址！"
        );
      }
      this.handleClose();
      this.$emit("add", item.showText);
    },

    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
  },
};
</script>

<style lang="scss" scoped>
.message-text-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #fff;
  border-radius: 20px;
}

.message-text-container.expanded {
  height: 100%;
  .content-header {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-bottom: none;
  }
  .form-section {
    width: 800px;
    margin: 0 auto;
  }
  .result-section__wrap {
    width: 800px;
    margin: 0 auto;
    padding: 0px 20px;
  }
}

/* 顶部操作栏 */
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  color: #333;
  border-bottom: 1px solid #e9e9e9;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  position: relative;
}

.header-left {
  display: flex;
  align-items: center;
}

.collapse-btn {
  margin-right: 4px;
}

.back-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.back-btn img {
  width: 16px;
  height: 16px;
}

.content-title {
  font-size: 16px;
  font-weight: 500;
}

.content-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  cursor: pointer;
  width: 32px;
  height: 32px;
}

/* 表单区域 */
.form-section {
  padding: 20px;
}

.ai-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ai-form .el-form-item {
  margin-bottom: 0;
}

.ai-form .button-item {
  /deep/ .el-form-item__content {
    margin-left: 0px !important;
  }
  &__wrap {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
}

.ai-form .el-form-item__label {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.ai-form .el-input__inner {
  border-radius: 8px;
}

.tips-icon {
  width: 16px;
  height: 16px;
  margin-left: 30px;
  cursor: pointer;
}

.generate-btn {
  border: none;
  border-radius: 24px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 15px;
  width: 335px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: linear-gradient(-10deg, #2986fe 0%, #d7abff 100%), #d9d9d9;
  border-radius: 21px 21px 21px 21px;
}

/* 结果区域 */
.result-section {
  flex: 1;
  padding: 20px;
  background: #f8f9fa;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  overflow-y: auto;
  border-top: 1px solid #e9e9e9;
  display: flex;
}

.result-section__wrap {
  width: 100%;
}

.result-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}

.result-icon {
  width: 120px;
  height: 120px;
  margin-bottom: 16px;
}

.result-title {
  font-size: 16px;
  color: #303133;
  margin: 0 0 8px 0;
}

.result-desc {
  font-size: 14px;
  color: #8186a5;
  margin: 0;
}

.flex-row {
  display: flex;
  align-items: center;
  height: 32px;
}

.chat_window {
  width: 100%;
  height: 100%;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }

  .item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    &:last-child {
      margin-bottom: 20px;
    }

    img {
      width: 40px;
      height: 40px;
    }

    .message {
      position: relative;
      max-width: 450px;
      line-height: 20px;
      font-size: 14px;
      word-break: break-all;

      span {
        white-space: pre-wrap;
      }
    }

    .AI {
      color: #333333;
      padding: 0px;
      max-width: 100%;
    }

    .monkey {
      background: #ddeaff;
      border-radius: 16px;
      color: #333;
      padding: 12px 16px;
    }
  }

  .left {
    justify-content: start;
    padding-bottom: 50px;
    margin-bottom: 0px;
    &:hover {
      .message_handle {
        display: flex;
      }
    }
  }

  .right {
    justify-content: end;
  }
}
.tips {
  color: #666666;
  font-size: 12px;
  margin-top: 2px;

  .num {
    color: #3159ff;
  }
}
.point-input ::v-deep .el-textarea__inner {
  &::placeholder {
    color: rgb(191, 191, 191);
    font-size: 14px;
  }
}
</style>